// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___34gSA","open":"open___1vQPg","table":"table___3zWdk"};